import { render, staticRenderFns } from "./percentage-reports.vue?vue&type=template&id=632cb771"
import script from "./percentage-reports.vue?vue&type=script&lang=js"
export * from "./percentage-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports